import { render, staticRenderFns } from "./SignDetails.vue?vue&type=template&id=037ccf9b&scoped=true&"
import script from "./SignDetails.vue?vue&type=script&lang=js&"
export * from "./SignDetails.vue?vue&type=script&lang=js&"
import style0 from "./SignDetails.vue?vue&type=style&index=0&id=037ccf9b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037ccf9b",
  null
  
)

export default component.exports